import {AuthRequestStatusEnum} from 'domain/usecases';
import {makeGetAuthRequests} from 'main/factories/usecases/private/authorizations';
import {DateFormatEnum} from 'presentation/constants';
import {formatDateString} from 'presentation/utils';
import {FilteredAuthorizationsParams, Params} from './types';

export const getRequestsList = async ({
	page,
	size,
	filterAuthRequestsByStatus,
	signal,
}: FilteredAuthorizationsParams) => {
	const params: Params = {
		page,
		size,
		signal,
	};

	const hasFilterAuthRequestsByStatus =
		filterAuthRequestsByStatus &&
		filterAuthRequestsByStatus.toUpperCase() !== AuthRequestStatusEnum.TODOS;

	if (hasFilterAuthRequestsByStatus) {
		params.situacoes = filterAuthRequestsByStatus.toUpperCase();
	}

	try {
		const response = await makeGetAuthRequests().get(params);

		const formattedRequests = response.items?.map(request => ({
			...request,
			dsSituacao: request.dsSituacao?.replace(/_/g, ' ').toLocaleLowerCase(),
			dtSolicitacao: formatDateString(
				request.dtAutorizacao,
				DateFormatEnum.DATE_FORMAT_7,
				DateFormatEnum.DATE_FORMAT_8,
			),
		}));

		const responseFormatted = {
			...response,
			items: [...formattedRequests],
		};

		return responseFormatted;
	} catch (error) {
		throw new Error();
	}
};
